import { useEffect, useState } from 'react'

const STAGES = [
  { after: 0, text: 'Thinking...' },
  { after: 2000, text: 'Checking the right information for you...' },
  { after: 5000, text: 'Almost there...' },
]

export default function AdvisorThinking() {
  const [status, setStatus] = useState(STAGES[0].text)

  useEffect(() => {
    const timers = STAGES.slice(1).map((stage) => (
      setTimeout(() => setStatus(stage.text), stage.after)
    ))
    return () => timers.forEach(clearTimeout)
  }, [])

  return (
    <div
      className="advisor-msg advisor-msg-advisor advisor-thinking"
      role="status"
      aria-live="polite"
      aria-label="SMA Admissions Advisor is preparing a response"
    >
      <p className="advisor-thinking-label">SMA Admissions Advisor</p>
      <div className="advisor-typing" aria-hidden="true">
        <span className="advisor-typing-dot" />
        <span className="advisor-typing-dot" />
        <span className="advisor-typing-dot" />
      </div>
      <p className="advisor-thinking-status">{status}</p>
    </div>
  )
}
